import React, { useEffect, useState, Fragment, useRef } from "react";
import { DivisionReportTableContent } from '../../../Common/Table/tableContent';
import $ from "jquery";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

export default class ComponentToPrint extends React.Component {

    render() {

        const reportData = this.props.reportData;
        const avialablePluckingDeductions = this.props.avialablePluckingDeductions;
        const totalCollections = this.props.totalCollections;
        const searchData = this.props.searchData;

        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Division Summary Report (MPL)</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Search Date: </b> {searchData.searchDate}</div>
                </div>
                <div>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>Division</TableCell>
                                <TableCell rowSpan="2" align="center" style={{ fontWeight: "bold" }}>
                                    Field
                                </TableCell>
                                <TableCell align="center" colSpan={2 + avialablePluckingDeductions.length} style={{ background: "lightblue", fontWeight: "bold" }}>
                                    Plucker collection
                                </TableCell>
                                <TableCell align="center" colSpan="4" style={{ background: "lightgreen", fontWeight: "bold" }}>
                                    Field collection
                                </TableCell>
                                <TableCell align="center" colSpan="6" style={{ background: "lightyellow", fontWeight: "bold" }}>
                                    Factory collection
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {avialablePluckingDeductions.map((x, index) => {
                                    return (
                                        <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }} key={index}>
                                            {x}
                                        </TableCell>
                                    );
                                })}
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Original Weight
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Checkroll Weight
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    No Of Bags
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Actual Weight
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Gross Weight
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Net Weight
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Recieving Factory
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    No Of Bags
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Actual Weight
                                    </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Gross Weight
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Deduction
                                </TableCell>
                                <TableCell align="center" style={{ wordWrap: "break-word", fontWeight: "bold" }}>
                                    Net Weight
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody >
                            {reportData.map((row) => (
                                <TableRow key={row.employeeCode}>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.collectionPointName == undefined ? '-' : row.collectionPointName}
                                    </TableCell>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.fieldName == undefined ? '-' : row.fieldName}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.pluckingOriginalWeight == undefined ? '-' : parseFloat(row.pluckingOriginalWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.pluckingCheckrollWeight == undefined ? '-' : parseFloat(row.pluckingCheckrollWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.fieldNoOfBags == undefined ? '-' : row.fieldNoOfBags}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.fieldActualAmount == undefined ? '-' : parseInt(row.fieldActualAmount).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.fieldGrossWeight == undefined ? '-' : parseFloat(row.fieldGrossWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.fieldNetWeight == undefined ? '-' : parseFloat(row.fieldNetWeight).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.recievingFactory == undefined ? '-' : row.recievingFactory}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.factoryNoOfBags == undefined ? '-' : row.factoryNoOfBags}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.factoryActualAmount  == undefined ? '-' : parseFloat(row.factoryActualAmount ).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.factoryGross == undefined ? '-' : parseFloat(row.factoryGross).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.factoryMoistureDeduction == undefined ? '-' : parseFloat(row.factoryMoistureDeduction).toFixed(2)}
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row" style={{ fontWeight: row.isBold == undefined ? null : "bold" }}>
                                        {row.factoryNetWight == undefined ? '-' : parseFloat(row.factoryNetWight).toFixed(2)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan="2" align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>{parseFloat(totalCollections.pluckingOriginalWeight).toFixed(2)}
                                    {
                                        avialablePluckingDeductions.map((x, i) => {
                                            return (
                                                <td key={i} style={{ textAlign: "right" }}><b>{parseFloat(totalCollections[x]).toFixed(2)}</b></td>
                                            );
                                        })
                                    }
                                </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>{parseFloat(totalCollections.pluckingCheckrollWeight).toFixed(2)}</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}>{totalCollections.fieldNoOfBags}</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.fieldGrossWeight).toFixed(2)}</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.fieldNetWeight).toFixed(2)}</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> </TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {totalCollections.factoryNoOfBags}</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.factoryGross).toFixed(2)}</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.factoryMoistureDeduction).toFixed(2)}</TableCell>
                                <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold" }}> {parseFloat(totalCollections.factoryNetWight).toFixed(2)}</TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </div>
            </div>
        );
    }
}
